<template>
	<div class="overlay" :class="classes" :style="style">
		<div v-if="loader" class="loader" :style="loaderStyle">
			<t-timpex-icon
				icon="cog"
				type="bp"
				class="rotate"
				:size="loaderSize"
				:color="loaderColor"
			/>
		</div>
		<div class="overlay-content">
			<slot />
		</div>
	</div>
</template>

<script>
export default {
	name: 'TOverlay',
	props: {
		isShown: Boolean,
		absolute: Boolean,
		loader: Boolean,
		loaderSize: {
			type: String,
			default: 'xl'
		},
		loaderColor: {
			type: String,
			default: 'neutral'
		},
		/* loaderMarginBottom: Used to move the loader icon to align to TNoContentPanel icon if panel has text */
		loaderMarginBottom: {
			type: String,
			default: '15px'
		},
		color: {
			type: String,
			default: '#f5f6f7',
		},
		zIndex: {
			type: [ Number, String ],
			default: 1,
		},
	},
	computed: {
		style() {
			return {
				backgroundColor: this.color,
				zIndex: this.zIndex,
				opacity: this.isShown ? 1 : 0
			};
		},
		classes() {
			return {
				active: this.isShown,
				absolute: this.absolute
			};
		},
		loaderStyle() {
			return { marginBottom: this.loaderMarginBottom };
		}
	}
};
</script>


<style lang="scss" scoped>
.overlay {
	align-items: center;
	border-radius: inherit;
	display: flex;
	flex-direction: column;
	justify-content: center;
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	pointer-events: none;
	transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), z-index 1ms;
	&.active {
		pointer-events: auto;
		touch-action: none;
	}
	&.absolute {
		position: absolute;
	}
}

.overlay-content{
	user-select: none;
	font-weight: 500;
	text-align: center;
	margin-top: 15px;
	padding: 0px 15px;
}

@-moz-keyframes spin {
	from { -moz-transform: rotate(0deg); }
	to { -moz-transform: rotate(360deg); }
}
@-webkit-keyframes spin {
	from { -webkit-transform: rotate(0deg); }
	to { -webkit-transform: rotate(360deg); }
}
@keyframes spin {
	from {transform:rotate(0deg);}
	to {transform:rotate(360deg);}
}
.loader {
	display: flex;
	align-items: center;
	justify-content: center;
	height: 80px;
	width: 80px;
	border-radius: 100%;
	color: #7B8B9A;
	background-color: #EDF0F2;
}
.rotate {
	animation-name: spin;
	animation-duration: 4000ms;
	animation-iteration-count: infinite;
	animation-timing-function: linear;
}
</style>

<docs>
```jsx
<div style="height: 300px; position:relative;">
	<t-overlay :isShown="true" absolute loader/>
</div>
```
</docs>